const PHOTO = /^\/api\/media\/([a-z0-9]{32})\/$/

export function personaPhotoId(value?: string): string | null {
  return value ? (PHOTO.exec(value)?.[1] ?? null) : null
}

export function personaPhotoUrl(value?: string): string {
  return value && personaPhotoId(value) ? value : ''
}
